import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

export const consignmentOrderRefundTableOpt = () => {
  return [
    {
      label: 'Editar',
      key: 'edit',
      icon: <EditOutlined />,
      privilege: 'edit',
    },
    {
      label: 'Cancelar',
      key: 'cancel',
      icon: <DeleteOutlined />,
      privilege: 'delete',
    },
  ];
};

export const filterConst = {
  DELETE: 'delete',
  EDIT: 'edit',
  PDF: 'pdf',
};

export const consignOrderRefundStatusConst = {
  PENDING: 'Pendiente',
  APPROVED: 'Aprobada',
  CANCELED: 'Cancelada',
  DEFAULT: 'Desconocido',
};

export const consignOrderRefundConst = {
  header: 'Devolucion de consigna',
  prefix: '#',
  duplicateAllotment: 'Ya hay un producto con este lote',
  create: 'Crear devolucion de consigna',
  edit: 'Editar devolucion de consigna',
  approve: 'Aprobado',
};

export const refundStatus = [
  { label: 'Pendiente', value: 'Pendiente' },
  { label: 'Aprobado', value: 'Aprobado' },
];

export const consignmentOrderRefundModalConst = {
  total: 'Total',
  status: 'Estado de devolucion',
  refundAt: 'Fecha de devolucion',
  productName: 'Nombre de producto',
  quantityReceived: 'Cant. Recibida',
  quantityBilled: 'Cant. Facturada',
  noData: '-',
};
